/**
 * English - Banks translations
 */
export const banks = {
  bpd: 'Banco Popular Dominicano',
  banreservas: 'Banco de Reservas',
  scotiabank: 'Scotiabank',
  bhd: 'Banco BHD León',
  progreso: 'Banco del Progreso',
  santaCruz: 'Banco Santa Cruz',
  asociacionPopular: 'Asociación Popular de Ahorros y Préstamos',
  promerica: 'Banco Promerica',
  caribe: 'Banco Caribe',
  vimenca: 'Banco Vimenca',
  lafise: 'Banco LAFISE',
  ademi: 'Banco ADEMI',
  empire: 'Empire Bank',
  bellbank: 'Bellbank',
} as const;
